import React, { useRef } from 'react';
import { useLocation } from 'react-router-dom';
import ArtistList from './ArtistList';
import Header from '../header/Header';
import { routeConstants } from '../../../utils';
import ManagerList from './ManagerList';

function AdminListContainer() {
  const location = useLocation();
  const artistListRef = useRef();
  const managerListRef = useRef();
  const headerRef = useRef();
  const isArtistListPage = location && (location.pathname === routeConstants.ADMIN_ARTIST);

  const searchRecord = (search, filter, filteredBrand, isDemoFilter) => {
    if (isArtistListPage) {
      artistListRef.current.searchArtist(search, filter, filteredBrand, isDemoFilter);
    } else {
      managerListRef.current.searchManager(search, filter);
    }
  };

  return (
    <div>
      <div className="content-wrapper">
        <Header search={searchRecord} ref={headerRef} pathName={location.pathname} />
        {
          isArtistListPage
            ? (
              <ArtistList
                ref={artistListRef}
                setTotalCount={(count) => {
                  headerRef.current.setTotalCount(count);
                }}
              />
            )
            : (
              <ManagerList
                ref={managerListRef}
                setTotalCount={(count) => {
                  headerRef.current.setTotalCount(count);
                }}
              />
            )
        }
      </div>
    </div>
  );
}

export default AdminListContainer;
